import { render } from "./DropdownAIStrategy.vue?vue&type=template&id=21a34c1a&scoped=true"
import script from "./DropdownAIStrategy.vue?vue&type=script&lang=js"
export * from "./DropdownAIStrategy.vue?vue&type=script&lang=js"

import "./DropdownAIStrategy.vue?vue&type=style&index=0&id=21a34c1a&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-21a34c1a"

export default script